// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Lg50","col":"styles_col__1td3E"};